import React from 'react';
import './../css/Footer.css';
import DesignByteImg from './../../Assets/DesignByte.png';

const Footer = () => {
    return (
        <>
            <div className='footerOuter'>
                <div className="container footer">
                    <div className="infoSummary">
                        <h4>Shanmukh Magapu</h4>
                        <p><a href="mailto:mshannu@umich.edu"><i className="fas fa-envelope"></i> mshannu@umich.edu</a></p>
                        <p><a href="tel:7075667333"><i className="fas fa-phone-alt"></i> +1(313)9092278</a></p>
                        <p><a 
                                href="https://www.google.com/maps/place/Kakinada,+Andhra+Pradesh/@16.9767692,82.1771922,12z/data=!3m1!4b1!4m5!3m4!1s0x3a3827ddaf59b4f7:0x92f8ddb9c89a4803!8m2!3d16.9890648!4d82.2474648?hl=en"
                                target="_blank"
                            ><i className="fas fa-map-marker-alt"></i> Dearborn,Michigan , United States</a></p>
                        <p><a href="https://www.linkedin.com/in/shanmukh-magapu-a6639520b" target="_blank"><i className="fab fa-linkedin"></i> LinkedIn</a></p>
                        <p><a href="https://github.com/SHANMUKH405" target="_blank"><i className="fab fa-github"></i> Github</a></p>
                    </div>
                    <div className="projectSummary">
                        <h4>Projects</h4>
                        <p><a href="https://theportfolyo.com/" target="_blank">ThePortfolyo</a></p>
<p><a href="https://v1.theportfolyo.com/" target="_blank">V1.ThePortfolyo</a></p>
<p><a href="https://pasteelement.com/" target="_blank">PasteElement</a></p>
<p><a href="https://designbyte.shop/" target="_blank">DesignByte</a></p>
<p><a href="https://legalseva.org/" target="_blank">LegalSeva</a></p>
<p><a href="https://shanmukh405.github.io/Restaurant-Web-design/" target="_blank">Food_Cart</a></p>
<p><a href="https://shanmukh405.github.io/Shanmukh-Portfolio/" target="_blank">Resume_WebDesign</a></p>
<p><a href="https://vishnuspireapp.netlify.app/" target="_blank">VishnuSpire</a></p>
<p><a href="https://e-commercedata.netlify.app/" target="_blank">E-Commerce</a></p>
<p><a href="https://github.com/SHANMUKH405/Airbnc" target="_blank">Many Clones</a></p>

   

                    </div>
                    <div className="servicesSummary">
                        <h4>Services</h4>
                        <p>Full Stack Development</p>
                        <p>AWS</p>
                        <p>Data Science</p>
                        <p>Backend Development</p>
                    </div>
                </div>
            </div>
            <div className="copyright" style={{ backgroundColor: `gray`, fontSize: '1rem', padding: '0' }}>
                
            </div>
            <div className="copyright">
                <h1>Copyright &copy; 2023 Shanmukh Magapu. All Rights Reserved</h1>
            </div>
        </>
    )
}

export default Footer
